import React from 'react';
import { Link } from 'react-router-dom';
import { schoolPrograms } from '../mock';
import { Calendar, Users, BookOpen } from 'lucide-react';

const School = () => {
  return (
    <div className="min-h-screen pt-32">
      {/* Hero */}
      <section className="py-20">
        <div className="container-custom">
          <h1 className="heading-1 mb-8">THE GPS COACHING SCHOOL</h1>
          <p className="body-large max-w-3xl">
            A professional training institution for the GPS Method™. Small cohorts. Long-term development. Depth over scale.
          </p>
        </div>
      </section>

      {/* Philosophy */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-8">A SERIOUS TRAINING ENVIRONMENT</h2>
            <p className="body-medium mb-6">
              The GPS Coaching School is not a course. It is a professional training institution.
            </p>
            <p className="body-medium mb-6 text-secondary">
              We work in small cohorts, over extended periods, with direct guidance from the Method Director and senior faculty.
            </p>
            <p className="body-medium text-secondary">
              This is formation, not information. We develop practitioners, not consumers.
            </p>
          </div>
        </div>
      </section>

      {/* Programs */}
      <section className="py-20">
        <div className="container-custom">
          <h2 className="heading-2 mb-16 text-center">TRAINING PROGRAMS</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {schoolPrograms.map((program) => (
              <div key={program.id} className="card-standard p-8">
                <h3 className="heading-4 mb-4 text-primary">{program.title}</h3>
                <p className="caption mb-4 text-secondary">{program.duration}</p>
                <p className="body-small">{program.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Structure */}
      <section className="py-20 bg-card">
        <div className="container-custom">
          <h2 className="heading-2 mb-16 text-center">TRAINING STRUCTURE</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <Users size={48} className="text-primary" />
              </div>
              <h3 className="heading-5 mb-4 text-primary">Small Cohorts</h3>
              <p className="body-small">
                Limited places. Direct access to faculty. Individualized guidance throughout training.
              </p>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <Calendar size={48} className="text-primary" />
              </div>
              <h3 className="heading-5 mb-4 text-primary">Extended Timeline</h3>
              <p className="body-small">
                12-18 month programs. Real development takes time. No accelerated tracks.
              </p>
            </div>
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <BookOpen size={48} className="text-primary" />
              </div>
              <h3 className="heading-5 mb-4 text-primary">Ongoing Formation</h3>
              <p className="body-small">
                Advanced labs for continuing practitioners. The work deepens with practice.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Selection */}
      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <h2 className="heading-2 mb-8">SELECTION PROCESS</h2>
            <p className="body-medium mb-6">
              Admission to the GPS Coaching School is selective.
            </p>
            <p className="body-medium mb-6 text-secondary">
              We assess commitment, readiness, and alignment with the method's principles.
            </p>
            <p className="body-medium mb-12 text-secondary">
              Applications are reviewed on a rolling basis. We notify applicants within 7 days.
            </p>
            <Link to="/apply" className="btn-primary inline-flex items-center">
              Submit Application
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default School;